import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { filter } from "rxjs";
import { AppConfigService } from "./app-config.service";

@Injectable({ providedIn: "root" })
export class StartupModelRouteHandlerService {

    constructor(
        private router: Router,
        private appConfigService: AppConfigService,
    ) {}

    initStartupModelLoading() {

        if (!this.appConfigService.startupModelLoaded && !this.appConfigService.startupModelLoading) {

            this.appConfigService.loadStartupModelAsync(this.router.currentNavigation().extractedUrl.toString());
        }

        return true;
    }

    waitForStartupModelLoading() {

        return this.appConfigService.startupModelLoadingStatus$
            .pipe(
                filter(status => status === "LOADED"),
            );
    }
}
